import { React } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid, Divider, useMediaQuery
} from '@material-ui/core';
import MusicNoteIcon from '@material-ui/icons/MusicNote';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontFamily: 'Helvetica Neue',
  },
  sectionTwo: {
    backgroundColor: "#282828",
    paddingLeft: 20,
    paddingRight: 20,
    fontSize: "1.2rem",
  },
  sectionTwoMobile: {
    backgroundColor: "#282828",
    paddingLeft: 20,
    paddingRight: 20,
    fontSize: ".9rem",
  },
  innerGridContainer: {
    width: "100%",
    margin: "0px",
    padding: "30px"
  },
  innerGridContainerMobile: {
    width: "100%",
    margin: "0px",
    padding: "15px",
    fontSize: ".9rem",
  },
  sectionParagraph: {
    margin: "10px 0px",
    color: "#bdbdbd",
  },
  innerGridHeading: {
    width: "100%",
    textAlign: "center",
    color: "#FFF",
    fontSize: "3rem",
  },
  subParagraph: {
    margin: "10px 0px",
    fontSize: '1.5rem',
    width: "100%",
    textAlign: "center",
    color: "#bdbdbd",
  },
  iconDesign: {
    margin: "20px",
    backgroundColor: "#ffa000",
    color: '#FFF',
    borderRadius: '25px',
    width: "50px",
    height: "50px",
  },
  gridIconNdTextFlex: {
    display: 'flex',
    flexDirection: 'row',
  },
  iconDesignMobile: {
    margin: "10px",
    backgroundColor: "#ffa000",
    color: '#FFF',
    borderRadius: '15px',
    width: "35px",
    height: "35px",
  },
}));



export default function Home() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <div className={classes.root}>
      <section className={isMobile? classes.sectionTwo: classes.sectionTwoMobile}>
        <Grid className={isMobile ? classes.innerGridContainer : classes.innerGridContainerMobile}
          container
          spacing={2} >
          <Grid xs={12}>
            <h2  className={classes.innerGridHeading}>Vores services</h2>
            <Divider style={{ margin: 'auto', height: '2px', width: '60px', backgroundColor: "#FFF" }} />
            <br />
            <p className={classes.subParagraph}>
              Udover prodoktion og distribution, tilbyder vi ogsa radgivning i
              strategisk brug af lyddesign i savel <br />
              online som offlinder medier
            </p>
          </Grid>
          <Grid xs={12} md={6} style={{ color: "#FFF", padding: 40 }}>
            <Grid className={classes.gridIconNdTextFlex}>
              <MusicNoteIcon className={isMobile? classes.iconDesign: classes.iconDesignMobile} color="inherit" fontSize="large" />
              <p className={classes.sectionParagraph}>
                <h3>YudXzker</h3>
                Flere brandguruer har udnævnt lydbranding som det nye scoop indenfor branding  og lyd som det vigtigste element i opbygningen af et varemærke –
                foran syns og duftesans!
              </p>
            </Grid>
            <Grid className={classes.gridIconNdTextFlex}>
              <MusicNoteIcon className={isMobile? classes.iconDesign: classes.iconDesignMobile} color="inherit" fontSize="large" />
              <p className={classes.sectionParagraph}>
                <h3>LydereMader</h3>
                Flere brandguruer har udnævnt lydbranding som det nye scoop indenfor branding  og lyd som det vigtigste element i opbygningen af et varemærke –
                foran syns og duftesans!
              </p>
            </Grid>
            <Grid className={classes.gridIconNdTextFlex}>
              <MusicNoteIcon className={isMobile? classes.iconDesign: classes.iconDesignMobile} color="inherit" fontSize="large" />
              <p className={classes.sectionParagraph}>
                <h3>MatherPader</h3>
                Flere brandguruer har udnævnt lydbranding som det nye scoop indenfor branding  og lyd som det vigtigste element i opbygningen af et varemærke –
                foran syns og duftesans!
              </p>
            </Grid>

          </Grid>
          <Grid xs={12} md={6} style={{ color: "#FFF", padding: 40 }}>
            <Grid className={classes.gridIconNdTextFlex}>
              <MusicNoteIcon className={isMobile? classes.iconDesign: classes.iconDesignMobile} color="inherit" fontSize="large" />
              <p className={classes.sectionParagraph}>
                <h3>SishterBrathder</h3>
                Flere brandguruer har udnævnt lydbranding som det nye scoop indenfor branding  og lyd som det vigtigste element i opbygningen af et varemærke –
                foran syns og duftesans!
              </p>
            </Grid>
            <Grid className={classes.gridIconNdTextFlex}>
              <MusicNoteIcon className={isMobile? classes.iconDesign: classes.iconDesignMobile} color="inherit" fontSize="large" />
              <p className={classes.sectionParagraph}>
                <h3>Shoreder</h3>
                Flere brandguruer har udnævnt lydbranding som det nye scoop indenfor branding  og lyd som det vigtigste element i opbygningen af et varemærke –
                foran syns og duftesans!
              </p>
            </Grid>
            <Grid className={classes.gridIconNdTextFlex}>
              <MusicNoteIcon className={isMobile? classes.iconDesign: classes.iconDesignMobile} color="inherit" fontSize="large" />
              <p className={classes.sectionParagraph}>
                <h3>Epikaers</h3>
                Flere brandguruer har udnævnt lydbranding som det nye scoop indenfor branding  og lyd som det vigtigste element i opbygningen af et varemærke –
                foran syns og duftesans!
              </p>
            </Grid>

          </Grid>
        </Grid>

      </section>
    </div>
  )
}